import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-10">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[340px_1fr]">
          <div>
            <span className="font-label text-xs tracking-widest text-primary-600">FAQ</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              常见问题
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              这里整理了浏览「善良的小姨子在线观看」时最常遇到的几个疑问。点击问题即可展开答案，再次点击可以收起。
            </p>
            <div className="mt-6 rounded-lg border border-secondary-200 bg-secondary-50 p-5">
              <div className="flex items-center gap-2 text-secondary-900">
                <i className="ri-lightbulb-line text-lg"></i>
                <span className="font-label text-sm font-medium">还是卡顿？</span>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-secondary-900/80">
                优先尝试切换播放线路，而不是反复刷新页面，通常能更快恢复播放。
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={faq.q}
                  className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
                >
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => toggle(index)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="font-heading text-base font-semibold text-foreground-950">
                      {faq.q}
                    </span>
                    <i
                      className={`shrink-0 text-xl text-primary-500 transition-transform duration-300 ${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </button>
                  {isOpen && (
                    <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-700">
                      {faq.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}